import { FriendAvatarsStack, type FriendAvatar } from '../ui/FriendAvatarsStack';

type SocialProofLineProps = {
  people: FriendAvatar[];
  text: string;
  timestamp: string;
  onOpenPerson?: (personId: string) => void;
};

export function SocialProofLine({ people, text, timestamp, onOpenPerson }: SocialProofLineProps) {
  const firstPersonId = people[0]?.id ?? null;

  return (
    <div className="social-proof-line">
      <FriendAvatarsStack friends={people} max={3} size={24} />
      {firstPersonId && onOpenPerson ? (
        <button
          className="social-proof-line__text social-proof-line__author"
          type="button"
          onClick={() => onOpenPerson(firstPersonId)}
        >
          {text}
        </button>
      ) : (
        <span className="social-proof-line__text">{text}</span>
      )}
      <time className="social-proof-line__time">{timestamp}</time>
    </div>
  );
}
